import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./About.css";
import chaiLogo from "../assets/chaitanya-upda.png";
import AjayLogo from "../assets/AjayLogo.jpeg";
import SarvadipLogo from "../assets/sarvadip_datkhil.jpeg";
import JayLogo from "../assets/jaykumar_Gend.jpeg";
import AdilLogo from "../assets/Adil_habib.jpeg";

function About() {
  const founders = [
    {
      name: "Mr. Chaitanya Tandale",
      role: "M.D & Founder",
      img: chaiLogo,
      quote:
        "Klyzen Ventures is built on the belief that innovation across industries is the key to sustainable global growth.",
    },

      {
      name: "Mr. JayKumar Gend",
      role: "CEO & Co-Founder",
      img: JayLogo,
      quote:
        "Our focus is to create impact at scale by blending technology, education, and enterprise-driven solutions.",
    },
    
      {
      name: "Mr. Ajay Vaidya",
      role: "CHIEF TECHNOLOGY OFFICER",
      img: AjayLogo,
      quote:
        "Driving innovation through cutting-edge technology, building scalable digital solutions, and ensuring excellence in every product we create.",
    },
    
      {
      name: "Mr. Adil Habib",
      role: "CHIEF MARKETING OFFICER",
      img: AdilLogo,
      quote:
        "Creating impactful marketing strategies, strengthening brand presence, and building lasting relationships with customers worldwide.",
    },

    {
      name: "Mr. Sarvadip Datkhil",
      role: "CHIEF OPERATING OFFICER",
      img: SarvadipLogo,
      quote:
        "Leading operational excellence by streamlining processes, improving efficiency, and ensuring seamless execution across the organization.",
    }

   

    
  ];

  const divisions = [
    "Technology & IT",
    // "Education & Training",
    "Consulting & Recruitment",
    // "Food & Hospitality",
    // "Pet Care & Animal Welfare",
    "Media & Entertainment",
    // "Retail & Consumer",
    "Industrial & Manufacturing",
    "Health & Wellness",
    "Logistics & Transport",
    "Finance & Investments",
    "Agriculture & Environment",
    
  ];

  return (
    <>
      <Navbar />

      {/* HERO */}
      {/* HERO */}
      <section className="about-hero">
        <div className="about-hero-overlay" />
        <div className="about-hero-content">
          <h1 className="about-main-heading">
            A Diversified Global Venture Group
          </h1>
          <div className="hero-divider"></div>
          <p>
            Klyzen Ventures LLP operates across multiple industries, combining
            innovation, technology, and strategic expertise to build scalable,
            future-ready enterprises.
          </p>
        </div>
      </section>


      {/* INTRO */}
      <section className="about-section about-intro">
        <h2>Who We Are</h2>
        <p>
          Klyzen Ventures LLP is a multi-division organization working across
          technology, education, manufacturing, consulting, and emerging
          industries. We design, build, and scale solutions that drive long-term
          value for businesses, startups, and communities worldwide.
        </p>
      </section>

      {/* MISSION / VISION */}
      <section className="about-section mission-vision">
        <div className="mv-card">
          <h3>Our Mission</h3>
          <p>
            To innovate across industries, empower talent, and deliver impactful
            solutions that shape the future of global business and technology.
          </p>
        </div>
        <div className="mv-card">
          <h3>Our Vision</h3>
          <p>
            To become a globally recognized venture group driving innovation,
            sustainability, and excellence across diverse sectors.
          </p>
        </div>
      </section>

      {/* INDUSTRIES */}
      <section className="about-section about-alt-bg">
        <h2>Industries We Operate In</h2>
        <p className="section-subtitle">
          Our diversified portfolio enables us to innovate, scale, and create
          impact across 20+ industry verticals.
        </p>

        <div className="industries-grid">
          {divisions.map((item, idx) => (
            <div key={idx} className="industry-card">
              {item}
            </div>
          ))}
        </div>
      </section>

      {/* LEADERSHIP */}
 <section className="about-section about-founder-msg">
        <h2>Leadership Team</h2>
     <div className="founders-wrapper">
          {founders.slice(0, 2).map((founder, idx) => (
         <div key={idx} className="founder-card">
         <img src={founder.img} alt={founder.name} />
         <h4>{founder.name}</h4>
         <span className="founder-role">{founder.role}</span>
         <blockquote>{founder.quote}</blockquote>
         </div>
         ))}
     </div>

    <div className="founders-wrapper">
         {founders.slice(2, 5).map((founder, idx) => (
         <div key={idx} className="founder-card">
         <img src={founder.img} alt={founder.name} />
         <h4>{founder.name}</h4>
         <span className="founder-role">{founder.role}</span>
         <blockquote>{founder.quote}</blockquote>
        </div>
        ))}
    </div>

  </section>

      <Footer />
    </>
  );
}

export default About;
